import {
  fetch,
  normalize,
  extractHubURL
} from '../../utils/dataAccess';
import { success as deleteSuccess } from './delete';
import filterStorage from "../../utils/filtersStorage";
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'ONEWAYINTERVIEW_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'ONEWAYINTERVIEW_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'ONEWAYINTERVIEW_LIST_SUCCESS', retrieved };
}

export function list(page = 'on_demand_interviews') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'ONEWAYINTERVIEW_LIST_RESET' });
    dispatch(deleteSuccess(null));
  };
}

export function filter(filtersData) {
  return filterAction( 'ONEWAYINTERVIEW_LIST_FILTER', 'company_one_way_interview', filtersData)
}

export function sort(sortData) {
  return sortAction('ONEWAYINTERVIEW_LIST_SORT','company_one_way_interview', sortData)
}
